import { FontFa } from "../components";

export const getFileIcon = (fileName: string) => {
  const fileExtension = fileName.split(".").pop();
  switch (fileExtension) {
    case "doc":
    case "docx":
      return <FontFa name="faFileWord" size="lg" color={"#0F4C81"} />;
    case "pptx":
    case "ppt":
      return <FontFa name="faFilePowerpoint" size="lg" color={"#D04423"} />;
    case "xlsx":
      return <FontFa name="faFileExcel" size="lg" color={"#1d6f42"} />;
    case "pdf":
      return <FontFa name="faFilePdf" size="lg" color={"#B0171F"} />;
    case "png":
    case "jpg":
    case "jepg":
      return <FontFa name="faFileImage" size="lg" color={"#0F4C60"} />;
    default:
      return <FontFa name="faFileCode" size="lg" />;
  }
};
